// extracted by mini-css-extract-plugin
export default {"validationMessage":"ValidationMessage_validationMessage__5K0eg"};